
<script>
import ArrowIcon from '@/assets/images/icons/slider-arrow.svg?inline'
import sliderImage from '@/assets/images/slider-image.jpg'

export default {
  name: 'Slider',
  components: {
    ArrowIcon
  },
  data: () => ({
    slider: 0,
    slides: [
      sliderImage,
      sliderImage,
      sliderImage,
      sliderImage,
      sliderImage
    ]
  }),
  methods: {
    slidePrev() {
      this.slider = this.slider === 0
        ? this.slider = this.slides.length - 1
        : this.slider - 1
    },
    slideNext() {
      this.slider = this.slider === this.slides.length - 1
        ? this.slider = 0
        : this.slider + 1
    }
  }
}
</script>
<template>
  <div class="slider">
    <b-carousel
      v-model="slider"
      :autoplay="false"
      :arrow-hover="false"
      :indicator="false"
      :arrow="false"
    >
      <div class="slider__pagination">
        <div class="slider__pagination-container">
          <button
            v-for="dot in slides.length"
            :key="dot"
            class="slider__pagination-dot"
            :class="{
              'slider__pagination-dot--active': slider === dot - 1
            }"
            @click="slider = dot - 1"
          />
        </div>
      </div>
      <div class="slider__controls">
        <button
          class="slider__controls-button slider__controls-button--prev"
          @click="slidePrev"
        >
          <arrow-icon
            fill="#fff"
          />
        </button>
        <button
          class="slider__controls-button"
          @click="slideNext"
        >
          <arrow-icon
            fill="#fff"
          />
        </button>
      </div>
      <b-carousel-item
        v-for="(slide, index) in slides"
        :key="index"
      >
        <div class="slider__slide">
          <img :src="slide">
        </div>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>